import { useHistory, useParams } from 'react-router'
import { useEffect, useState } from 'react'
import { checkLbpToken } from '../services/Kyc'
import { extractStatusCode, setUploadCount } from '../services/utils'
import { FORBIDDEN_ERROR } from '../enums/common'
import { ROUTES } from '../enums/routes'

const useLoginHook = () => {
  const { token } = useParams()
  const history = useHistory()
  const [isCheckingToken, setCheckingToken] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')

  useEffect(() => {
    async function checkToken(kycToken: string) {
      setCheckingToken(true)
      try {
        const { phone_number } = await checkLbpToken(kycToken)
        setPhoneNumber(phone_number)
        setUploadCount()
      } catch (e) {
        const status = extractStatusCode(e)
        if (status === FORBIDDEN_ERROR) {
          history.push(ROUTES.unauthenticated)
        }
      } finally {
        setCheckingToken(false)
      }
    }

    if (token) {
      checkToken(token)
    }
  }, [token, history])

  return {
    isCheckingToken,
    phoneNumber,
  }
}

export default useLoginHook
